import client from "../client";

export interface KanbanStatuses {
  title: string;
  value: string;
  kanbanSettingType: number;
}

class KanbanSerice {
  async get(): Promise<KanbanStatuses | null> {
    try {
      const url = "/api/KanbanSetting";

      const { data, status } = await client.get<KanbanStatuses[]>(url);

      if (status !== 200 || !data?.length) {
        return null;
      }

      return data[0];
    } catch (error) {
      console.error("Failed to fetch Kanban settings:", error);
      throw error;
    }
  }

  async Save(value: string) {
    try {
      let url = `/api/KanbanSetting`;
      const status = {
        title: "Statuses",
        value: value,
        kanbanSettingType: 1,
      };
      const { data } = await client.post<KanbanStatuses>(url, status);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new KanbanSerice();
